export default __webpack_public_path__ + "static/media/gear.dcc81b5b.gif";